/* eslint-disable @typescript-eslint/no-explicit-any */
import { create } from 'zustand';

type FinanceStore = {
  financeListPage: number;
  setFinanceListPage: (page: number) => void;
  financeListLimit: number;
  setFinanceListLimit: (limit: number) => void;
  filter: null;
  setFilter: (filter: any) => void;
};

export const useFinanceStore = create<FinanceStore>((set) => ({
  financeListLimit: 10,
  financeListPage: 1,
  setFinanceListPage: (financeListPage) => set({ financeListPage }),
  setFinanceListLimit: (financeListLimit) => set({ financeListLimit }),
  filter: null,
  setFilter: (filter) => set({ filter }),
}));
